<template>
  <div id="tac-admin-dropship-sync-inventory__dashboard">
    <ol class="breadcrumb">
      <li><a href="/admin">Admin</a></li>
      <li><a href="/admin/dropship">Dashboard</a></li>
      <li><a href="/admin/dropship/seller">Seller</a></li>
      <li><router-link :to="{name: 'admin/dropship/seller/sync/dashboard'}">Sync</router-link></li>
      <li class="active">Inventory</li>
    </ol>
    <div class="page-header">
      <h1 class="page-header-title">
        <span class="fa fa-fw fa-exchange"></span>
        Inventory Sync <small>Pull from supplier</small>
      </h1>
    </div><!-- .page-header -->
    <div class="page-body">
      <div class="row">
        <div class="col-lg-6">
          <sync-form></sync-form>
        </div>
      </div>
    </div><!-- .page-body -->
  </div><!-- #tac-admin-dropship-sync-inventory__dashboard -->
</template>

<script>
import SyncForm from './SyncForm'

export default {
  created() {
    this.fetchOptions()
  },
  methods: {
    fetchOptions() {
      this.$store.dispatch('dropship/seller/syncInventory/fetchOptions')
    }
  },
  components: {
    SyncForm
  }
}
</script>
